/* unplugin-vue-components disabled */import { render } from "./AdminToggleDark.vue?vue&type=template&id=5c149ed5&scoped=true"
import script from "./AdminToggleDark.vue?vue&type=script&lang=js"
export * from "./AdminToggleDark.vue?vue&type=script&lang=js"

import "./AdminToggleDark.vue?vue&type=style&index=0&id=5c149ed5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c149ed5"]])

export default __exports__